<!-- Footer-->
<footer class="footer pt-lg-5 pt-4 bg-dark text-light">
  <div class="container mb-4 py-4 pb-lg-5">
    <div class="row gy-4">
      <div class="col-lg-3 col-md-6 col-sm-4">
        <div class="mb-4 pb-sm-3"><a class="d-inline-block" routerLink=""><img src="assets/img/logo/logo-light.png" width="116" alt="Logo"></a></div>
        <ul class="nav nav-light flex-column">
          <li class="nav-item mb-2"><a class="nav-link p-0 fw-normal text-light text-nowrap" href="mailto:contact&#64;annuaire-niger.com"><i class="fi-mail mt-n1 me-1 align-middle text-primary"></i>contact&#64;annuaire-niger.com</a></li>
          <li class="nav-item mb-2"><a class="nav-link p-0 fw-normal text-light text-nowrap" href="tel:+22796892740"><i class="fi-device-mobile mt-n1 me-1 align-middle text-primary"></i>+227 96 89 27 40</a></li>
        </ul>
      </div>
      <!-- Liens utiles -->
      <div class="col-lg-2 col-md-3 col-sm-4">
        <h3 class="fs-base text-light">Liens utiles</h3>
        <ul class="list-unstyled fs-sm">
          <li><a class="nav-link-light" href="catalog/grid?type=entreprises">Entreprises</a></li>
          <li><a class="nav-link-light" href="catalog/grid?type=pharmacies">Pharmacies</a></li>
          <li><a class="nav-link-light" href="catalog/grid?type=institutions">Institutions</a></li>
          <li><a class="nav-link-light" href="catalog/offres">Offres Publics / Privés</a></li>
          <li><a class="nav-link-light" href="catalog/gov">Textes / Officiels</a></li>
        </ul>
      </div>
      <!-- Profil -->
      <div class="col-lg-2 col-md-3 col-sm-4">
        <h3 class="fs-base text-light">Mon espace</h3>
        <ul class="list-unstyled fs-sm">
          <li><a class="nav-link-light" href="javascript:void(0);" (click)="redirectToWhatsApp('Mettre à jour les informations de mon entreprise')">Faire une annonce</a></li>
          <li><a class="nav-link-light" href="javascript:void(0);" (click)="redirectToWhatsApp('Mettre à jour les informations de mon entreprise')">Ajouter ma publicité</a></li>
          <li><a class="nav-link-light" href="javascript:void(0);" (click)="redirectToWhatsApp('Mettre à jour les informations de mon entreprise')">Mettre à jour mon entreprise</a></li>
          <li><a class="nav-link-light" href="javascript:void(0);" (click)="redirectToWhatsApp('Mettre à jour les informations de mon entreprise')">Ajouter mon entreprise</a></li>
        </ul>
      </div>
      <!-- Abonnement -->
      <div class="col-lg-4 offset-lg-1">
        <h3 class="h4 text-light">Abonnez-vous à notre page Facebook</h3>
        <p class="fs-sm mb-4 opacity-60">Ne manquez aucune mise à jour des entreprises et institutions du Niger</p>
        <form class="form-group form-group-light rounded-pill" style="max-width: 500px;">
          <button class="btn btn-primary btn-sm rounded-pill"  href="" type="button">S'abonner</button>
        </form>
      </div>
    </div>
  </div>
  <div class="py-4 border-top border-light">
    <div class="container d-flex flex-column flex-lg-row align-items-center justify-content-between py-2">
      <!-- Copyright-->
      <p class="order-lg-1 order-2 fs-sm mb-2 mb-lg-0"><span class="text-light opacity-60">&copy; 2024 Annuaire Niger. Tous droits réservés.</span></p>
      <div class="d-flex flex-lg-row flex-column align-items-center order-lg-2 order-1 ms-lg-4 mb-lg-0 mb-4">
        <!-- Liens-->
        <div class="d-flex flex-wrap fs-sm mb-lg-0 mb-4 pe-lg-4"><a class="nav-link-light px-2 mx-1" href="javascript:void(0);">À propos</a><a class="nav-link-light px-2 mx-1" href="javascript:void(0);">Blog</a><a class="nav-link-light px-2 mx-1" href="javascript:void(0);">Support</a><a class="nav-link-light px-2 mx-1" href="javascript:void(0);">Contacts</a></div>
        <div class="d-flex align-items-center">
          <!-- Sélecteur de langue -->
          <div class="dropdown" ngbDropdown>
            <a class="nav-link nav-link-light dropdown-toggle fs-sm align-items-center p-0 fw-normal" href="javascript:void(0);" id="langSwitcher" data-bs-toggle="dropdown" role="button" aria-expanded="false" ngbDropdownToggle>
              <i class="fi-globe mt-n1 me-2 align-middle"></i>Français
            </a>
          </div>
          <!-- Réseaux sociaux -->
          <div class="ms-4 ps-lg-2 text-nowrap"><a class="btn btn-icon btn-translucent-light btn-xs rounded-circle ms-2" href="javascript:void(0);"><i class="fi-facebook"></i></a><a class="btn btn-icon btn-translucent-light btn-xs rounded-circle ms-2" href="javascript:void(0);"><i class="fi-twitter"></i></a><a class="btn btn-icon btn-translucent-light btn-xs rounded-circle ms-2" href="javascript:void(0);"><i class="fi-telegram"></i></a><a class="btn btn-icon btn-translucent-light btn-xs rounded-circle ms-2" href="javascript:void(0);"><i class="fi-messenger"></i></a></div>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- Bouton flottant WhatsApp -->
<div class="floating-whatsapp">
  <button class="btn btn-success rounded-circle" (click)="toggleWhatsAppOptions()">
    <i class="fi-whatsapp fs-4"></i>
  </button>
  <div class="whatsapp-options" *ngIf="showWhatsAppOptions">
    <button class="btn btn-light mb-2" (click)="redirectToWhatsApp('Mettre à jour les informations de mon entreprise')">
      Mettre à jour les informations de mon entreprise
    </button>
    <button class="btn btn-light" (click)="redirectToWhatsApp('Faire une demande d\'ajout de mon entreprise')">
      Faire une demande d'ajout de mon entreprise
    </button>
  </div>
</div>